const fonts = {
  body: 'Roboto',
  heading: 'Roboto',
};

export default fonts;
